const OLD_PREFIX = 'http://skin-assets.betacoders.net/';
const NEW_PREFIX =
  'https://storage.uk.cloud.ovh.net/v1/AUTH_948ebf6d457f4ea4802e51b22bfce599/skin-assets/';

export function normalizeSkinUrl(url) {
  if (!url) return '';

  if (url.startsWith(OLD_PREFIX)) {
    const fileName = url.replace(OLD_PREFIX, '');
    return NEW_PREFIX + fileName;
  }

  return url;
}